import { lazy } from 'react';
import { wrapNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { ClaimGiftFlowPageContentProps } from './ReferralGiftingClaimGiftFlowPageContent';

const ReferralGiftingClaimGiftFlowPageContent = lazy(
  () => import('./ReferralGiftingClaimGiftFlowPageContent'),
);

export const ReferralGiftingClaimGiftFlowPage = wrapNavigatorScreen(
  (props: ClaimGiftFlowPageContentProps) => {
    return <ReferralGiftingClaimGiftFlowPageContent {...props} />;
  },
  {
    cardOverlayEnabled: true,
    animationEnabled: false,
    detachPreviousScreen: false,
    cardStyle: {
      backgroundColor: 'transparent',
    },
    headerShown: false,
  },
);
